import React, { PureComponent } from 'react';
import { Button, Popover } from 'antd';
import { MeasureId } from 'app/model/CORE';
import { BUNCHING_WARNING_CLAZZ_VALUE, BunchingWarning, MeasureWarning } from 'app/model/SOL49';
import { Flex } from 'app/components/common/Flex';
import TimeUtils from 'app/common/util/TimeUtils';
import { ModalHandler } from 'app/components/panels/ModalHandler';
import './MeasureWarnings.less';
import ConditionalRender from 'app/common/components/ConditionalRender';
import AppContext from 'app/common/context/AppContext';

interface MeasureWarningProps {
    warnings: MeasureWarning[];
    measureId: MeasureId;
}

export class MeasureWarnings extends PureComponent<MeasureWarningProps> {
    getWarningPopoverContent = <T extends MeasureWarning>(warning: T, measureId) => {
        switch (warning.clazz) {
            case BUNCHING_WARNING_CLAZZ_VALUE:
                const bunchingWarning: BunchingWarning = warning;
                return (
                    <Flex direction="vertical" className="warning-popover-content">
                        <Flex className="info">
                            {bunchingWarning.nbFlights} flights - Peak at{' '}
                            {TimeUtils.formatHHMM(bunchingWarning.bunchingTime)}
                        </Flex>
                        <Flex direction="vertical" className="vertical-buttons-container">
                            <ConditionalRender condition={AppContext.isNmvpBaseline()}>
                                <Button disabled={false} onClick={() => ModalHandler.showSlotList(measureId)}>
                                    Slot list
                                </Button>
                            </ConditionalRender>
                            <Button
                                disabled={false}
                                onClick={() => ModalHandler.showRegulationEditor(measureId.id, 'reg')}>
                                Edit regulation
                            </Button>
                        </Flex>
                    </Flex>
                );
        }
        return <div className="warning-popover-content" />;
    };

    getWarningPopoverTitle = <T extends MeasureWarning>(warning: T) => {
        switch (warning.clazz) {
            case BUNCHING_WARNING_CLAZZ_VALUE:
                const bunchingWarning: BunchingWarning = warning;
                return (
                    <div className="warning-popover-title">
                        <div className="label">BUNCHING</div>
                        <div>{bunchingWarning.nbFlights} flights</div>
                    </div>
                );
        }
        return <div className="warning-popover-title">UNKNOWN</div>;
    };

    render() {
        const { warnings, measureId } = this.props;
        return (
            <div
                className="measure-warnings"
                onClick={
                    e => e.stopPropagation() /* Prevent selection of the measure when one of the warning is clicked */
                }>
                {warnings?.map((warning, index) => {
                    return (
                        <Popover
                            key={'warning-' + index}
                            trigger="click"
                            placement="bottom"
                            title={this.getWarningPopoverTitle(warning)}
                            content={this.getWarningPopoverContent(warning, measureId)}>
                            <div className="icon">B</div>
                        </Popover>
                    );
                })}
            </div>
        );
    }
}
